import PdfPage from './PdfPage';

export type PendingAnchor = { pageNum: number; relX: number; relY: number } | null;

export function getPageClosestToContainerCenter(
  pages: Map<number, PdfPage>,
  container: HTMLDivElement
) {
  const containerCenterX = container.scrollLeft + container.clientWidth / 2;
  const containerCenterY = container.scrollTop + container.clientHeight / 2;

  let closestPage: PdfPage | undefined;
  let closestDistance = Infinity;

  pages.forEach((page) => {
    const canvas = page.getCanvas();
    if (!canvas) return;

    const canvasCenterX = canvas.offsetLeft + canvas.clientWidth / 2;
    const canvasCenterY = canvas.offsetTop + canvas.clientHeight / 2;

    const distance = Math.hypot(canvasCenterX - containerCenterX, canvasCenterY - containerCenterY);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestPage = page;
    }
  });

  return closestPage;
}

export function getPendingAnchorFromContainerCenter(
  pages: Map<number, PdfPage>,
  container: HTMLDivElement
) {
  const containerCenterX = container.scrollLeft + container.clientWidth / 2;
  const containerCenterY = container.scrollTop + container.clientHeight / 2;

  let anchorPage: PdfPage | undefined;
  let bestOverlap = 0;

  pages.forEach((page) => {
    const canvas = page.getCanvas();
    if (!canvas) return;

    const canvasLeft = canvas.offsetLeft;
    const canvasRight = canvas.offsetLeft + canvas.clientWidth;
    const canvasTop = canvas.offsetTop;
    const canvasBottom = canvas.offsetTop + canvas.clientHeight;

    const overlapLeft = Math.max(canvasLeft, containerCenterX - 50);
    const overlapRight = Math.min(canvasRight, containerCenterX + 50);
    const overlapTop = Math.max(canvasTop, containerCenterY - 50);
    const overlapBottom = Math.min(canvasBottom, containerCenterY + 50);

    if (overlapLeft < overlapRight && overlapTop < overlapBottom) {
      const overlapArea = (overlapRight - overlapLeft) * (overlapBottom - overlapTop);
      if (overlapArea > bestOverlap) {
        bestOverlap = overlapArea;
        anchorPage = page;
      }
    }
  });

  if (!anchorPage) {
    anchorPage = getPageClosestToContainerCenter(pages, container);
  }

  if (!anchorPage) return null;
  const canvas = anchorPage.getCanvas();
  if (!canvas) return null;

  const relX = Math.max(0, Math.min(1, (containerCenterX - canvas.offsetLeft) / canvas.clientWidth));
  const relY = Math.max(0, Math.min(1, (containerCenterY - canvas.offsetTop) / canvas.clientHeight));

  return { pageNum: anchorPage.pageNum, relX, relY };
}
